import { Link } from 'react-router-dom';

// The Bloom footer, rendered ONCE globally in App.js so it appears on every
// page — current and future. Do not add a per-page footer; it would duplicate.
const SiteFooter = () => (
    <footer className="site-footer">
        <div className="site-footer-links">
            <Link to="/compliance" className="site-footer-link">Standards &amp; Compliance</Link>
        </div>
        <div className="site-footer-links">
            <Link to="/terms" className="site-footer-link">Terms of Service</Link>
            <span className="site-footer-sep" aria-hidden="true">·</span>
            <Link to="/privacy" className="site-footer-link">Privacy Policy</Link>
        </div>
        <div className="site-footer-copy">© {new Date().getFullYear()} Bloom. All rights reserved.</div>
    </footer>
);

export default SiteFooter;
